// eslint-disable-next-line import/no-anonymous-default-export
export default {
  l10n: {
    currency: '\u20ac',
    date: {
      months: {
        full: [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ],
        abbr: [
          'ene.',
          'feb.',
          'mar.',
          'abr.',
          'may.',
          'jun.',
          'jul.',
          'ago.',
          'sep.',
          'oct.',
          'nov.',
          'dic.',
        ],
      },
      days: {
        full: [
          'Domingo',
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
        ],
        abbr: ['do.', 'lu.', 'ma.', 'mi.', 'ju.', 'vi.', 'sá.'],
      },
      patterns: {
        longDate: 'dddd, D MMMM YYYY',
        dateSlash: 'DD/MM/YYYY',
        dateShort: 'dddd D MMMM',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd, D [de] MMMM - HH[:]mm [h]',
        dateMediumReversed: 'H[:]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY [a las] H[:]mm',
        dateLarge: 'dddd, D [de] MMMM [a las] HH[:]mm',
        timeShort: 'HH:mm',
        timeMedium: 'DD[/]MM HH:mm',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['-n S', 'n S'],
      },
      group: {
        separator: '.',
        length: 3,
        abbr: ['', 'k', 'M', 'B'],
      },
      decimal: {
        separator: ',',
        length: 2,
      },
      plural: 'nplurals=2; plural=(n != 1);',
      ordinal: function (number) {
        return number + (number === 1 ? '°' : '°');
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Cesta'],
      Favourites: [null, 'Favoritos'],
      Delivery: [null, 'Envío'],
      Summary: [null, 'Resumen'],
      Order: [null, 'Pedido'],
      Categories: [null, 'Categorías'],
      'No results found': [null, 'No hemos encontrado ningún resultado'],
      'No favourites': [null, 'No hay favoritos'],
      'Empty cart': [null, 'Cesta vacía'],
      'No order': [null, 'Ningún pedido'],
      'Add to cart': [null, 'Añadir a la cesta'],
      Included: [null, 'Incluido'],
      Delete: [null, 'Eliminar'],
      Items: [null, 'Artículos'],
      Description: [null, 'Descripción'],
      Quantity: [null, 'Cantidad'],
      Price: [null, 'Precio'],
      'Where would you like to receive your order?': [
        null,
        '¿Dónde deseas recibir tu pedido?',
      ],
      Address: [null, 'Dirección'],
      'Address details': [null, 'Complemento de dirección'],

      'Estimated delivery date': [null, 'Fecha estimada de entrega'],
      'Confirm delivery': [null, 'Validar el envío'],
      Form: [null, 'Formulario'],
      'Winamax account address': [null, 'Dirección de tu cuenta Winamax'],
      'Other address': [null, 'Otra dirección'],
      'Please select an address in another country': [
        null,
        'Por favor seleccione una dirección en otro país',
      ],
      'Search an address': [null, 'Encontrar una dirección'],
      'Please complete required fields': [
        null,
        'Por favor complete los campos requeridos',
      ],
      'Enter your personal information': [null, 'Introduce tus datos'],
      'Address 2': [null, 'Dirección 2'],
      Postcode: [null, 'Código Postal'],
      City: [null, 'Ciudad'],
      'Telephone number': [null, 'Número de teléfono'],
      'I agree for my account to be debited': [
        null,
        'Acepto que mi cuenta sea debitada',
      ],
      Confirmation: [null, 'Confirmar'],
      Save: [null, 'Guardar'],
      'View order': [null, 'Ver el pedido'],
      'Back to the shop': [null, 'Volver a la Tienda'],
      Orders: [null, 'Pedidos'],
      Pay: [null, 'Pagar'],
      'Thank you': [null, 'Gracias'],
      'We have received your order': [null, 'Hemos recibido tu pedido.'],
      'You will receive a confirmation e-mail shortly': [
        null,
        'Recibirás en unos instantes un mail de confirmación.',
      ],
      'In progress': [null, 'En curso'],
      Completed: [null, 'Terminadas'],
      'Order status': [null, 'Estado de mi pedido'],
      'Contact support': [null, 'Contactar con el soporte'],
      'Track order': [null, 'Seguir mi pedido'],
      'Order date': [null, 'Fecha del pedido'],
      'Order number': [null, 'Número de pedido'],
      Sort: [null, 'Ordenar'],
      Miles: [null, 'Millas'],
      'View results': [null, 'Ver los resultados'],
      Recommended: [null, 'Recomendados'],
      'Price ascending': [null, 'Precio ascendiente'],
      'Price descending': [null, 'Precio descendiente'],
      'Show only products I can buy': [
        null,
        'Mostrar solo los productos que puedo comprar',
      ],
      Under: [null, 'Menos de'],
      Over: [null, 'Más de'],
      Validate: [null, 'Validar'],
      Cancel: [null, 'Anular'],
      'Confirm cancellation': [null, 'Confirmar la eliminación'],
      'Are you sure you want to delete this item?': [
        null,
        '¿Estás seguro de que quieres eliminar este elemento?',
      ],
      'Product added to favorites': [null, 'Producto añadido a favoritos'],
      'Product added to cart': [null, 'Producto añadido a la cesta'],
      'PRICE CHANGE': [null, 'CAMBIO DE PRECIO'],
      'The price of the %1$s product has changed. It will be adjusted in your cart.':
        [
          null,
          'El precio del producto %1$s ha cambiado. Se ajustará en la cesta.',
        ],
      'QUANTITY UNAVAILABLE': [null, 'CANTIDAD NO DISPONIBLE'],
      'We are sorry, the %1$s product is no longer available in the quantity you selected.':
        [
          null,
          'Lo sentimos, el producto %1$s no está disponible en la cantidad que has seleccionado',
        ],
      'Product unavailable': [null, 'Producto no disponible'],
      'We are sorry, the %1$s product is no longer available. It will be removed from your cart.':
        [
          null,
          'Lo sentimos, el producto %1$s no está disponible. Se eliminará de tu cesta.',
        ],
      Phone: [null, 'Teléfono'],
      All: [null, 'Todo'],
      Maintenance: [null, 'Mantenimiento'],
      Fitting: [null, 'Fitting'], // This is not translated, as "Fitting" might have different meanings. You might want to provide a context or use a Spanish equivalent based on the context.
      Manufacturer: [null, 'Fabricación'],
      Back: [null, 'Volver'],

      /// ORDER STATUS
      'Order ready for delivery': [null, 'Pedido listo para ser enviado'],
      'Order being prepared': [null, 'Pedido en preparación'],
      'Order in process': [null, 'Pedido en tratamiento'],
      'Order being delivered': [null, 'Pedido en servicio de reparto'],
      'This order requires some action on your part': [
        null,
        'El pedido necesita tu intervención',
      ],
      'Order being processed manually': [
        null,
        'Pedido siendo tratado manualmente',
      ],
      'Order completed': [null, 'Pedido completado'],
      'Order returned': [null, 'Pedido devuelto'],
      'Order cancelled': [null, 'Pedido cancelado'],
      'Order resubmitted': [null, 'Pedido reiniciado'],
      'Order refunded': [null, 'Pedido rembolsado'],

      // CART ERRORS
      IMPORTANT: [null, 'ATENCIÓN'],
      'Some products could not be ordered due to %1$s. \n You can find them in your cart.':
        [
          null,
          'Algunos pedidos no han podido ser enviados ya que %1$s. \n Puedes verlos en tu carrito',
        ],
      CONFIRM: [null, 'CONFIRMAR'],
      'Unable to order': [null, 'Pedido imposible'],
      'Your order could not be completed because of %1$s': [
        null,
        'Tu pedido no se ha podido llevar a cabo por %1$s.',
      ],
      'Your order could not be completed': [
        null,
        'Tu pedido no ha podido ser completado',
      ],
      'Back to cart': [null, 'Volver al carrito'],

      // DEBIT MILES ERRORS
      'an identical order in progress': [
        null,
        'hay otro pedido idéntico en curso',
      ],
      'a technical error': [null, 'un problema técnico'],
      'an error in the recipient of the bonus': [
        null,
        'ya que hay un error en el destinatario del bono',
      ],
      'an insufficient Miles balance': [
        null,
        'tienen un saldo de millas insuficiente',
      ],
      'a deposit limit reached on your account': [
        null,
        'un límite de depósito alcanzado en su cuenta',
      ],
      'You cannot offer this product to this player': [null, 'Este producto no puede ser regalado a este jugador'],

      // ADDITIONAL TRANSLATIONS
      'Log in to order': [null, 'Conectarse'],
      'Delete all filters': [null, 'Eliminar todos los filtros'],
      Materials: [null, 'Materiales'],
      'Next availability': [null, 'Próximamente disponible'],
      'All categories': [null, 'Ver todo'],
      Filters: [null, 'Filtrar'],
      'See all': [null, 'Ver todo'],
      'Check Details': [null, 'Ver detalles'],
      'Place Order': [null, 'Orden'],
      'Enter a nickname': [null, 'Introduce un nombre de usuario'],
      'Your order will be shipped in multiple shipments': [
        null,
        'Tu pedido será enviado en varios envíos',
      ],
      Offer: [null, 'Regalar'],
      View: [null, 'Ver'],
      'Express order': [null, 'Compra exprés'],
      Buy: [null, 'Comprar'],
      'Not enough miles. Please remove some items.': [
        null,
        'Millas insuficientes. Por favor, elimina algunos artículos.',
      ],
      'Not enough miles available for immediate order': [
        null,
        'Millas insuficientes para un pedido inmediato',
      ],
      'Place order': [null, 'Ordenar'],
      Confirm: [null, 'Confirmar'],
      'Empty Cart': [null, 'Vaciar la cesta'],
      'Please select colors and/or size': [
        null,
        'Por favor, selecciona color(es) y/o talla',
      ],
      'Dematerialized product': [null, 'Producto desmaterializado'],
      Message: [null, 'Mensaje'],
      MILES: [null, 'MILLAS'],
    },
  },
};
